import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'toggle', 'slider', 'status']

  connect() {
    this.updateDisplay()
  }

  toggle() {
    this.checkboxTarget.checked = !this.checkboxTarget.checked
    this.updateDisplay()
  }

  updateDisplay() {
    const isChecked = this.checkboxTarget.checked
    
    // Update toggle appearance
    if (isChecked) {
      this.toggleTarget.classList.add('bg-blue-600')
      this.toggleTarget.classList.remove('bg-gray-200', 'dark:bg-gray-600')
      this.sliderTarget.classList.add('translate-x-5')
      this.sliderTarget.classList.remove('translate-x-0')
    } else {
      this.toggleTarget.classList.remove('bg-blue-600')
      this.toggleTarget.classList.add('bg-gray-200', 'dark:bg-gray-600')
      this.sliderTarget.classList.remove('translate-x-5')
      this.sliderTarget.classList.add('translate-x-0')
    }

    // Update status text if it exists
    if (this.hasStatusTarget) {
      const enabledText = this.data.get('enabledText') || 'Enabled'
      const disabledText = this.data.get('disabledText') || 'Disabled'
      this.statusTarget.textContent = isChecked ? enabledText : disabledText
    }
    
    // Update aria-checked
    this.toggleTarget.setAttribute('aria-checked', isChecked ? 'true' : 'false')
  }
}